import Main from './core/Main';

global.Main = Main;
